export default class CartItem {
  constructor(id, name, price, imageSrc, href, pickupDate, dropOffDate, pickupTime)
  {
    this.id = id;
    this.name = name;
    this.price = price;
    this.imageSrc = imageSrc;
    this.href = href;
    this.pickupDate = pickupDate;
    this.dropOffDate = dropOffDate;
    this.pickupTime = pickupTime;
  }
}
